<div
  class="table-container"
  *ngIf="loggedInUser$ | async as loggedInUser">
  <div
    #headerScroll
    class="availability-table-header">
    <app-custom-availability-table-header
      *ngIf="calendarTableHelper$ | async as calendarTableHelper"
      [calendarTableHelper]="calendarTableHelper"
      [activeDayIndex]="(selectedDatesStartIndex$ | async) ?? undefined"
      [activeDayRange]="
        ((selectedDatesEndIndex$ | async) || 0) -
        ((selectedDatesStartIndex$ | async) || 0)
      "
      (daySelected)="
        daySelected($event)
      "></app-custom-availability-table-header>
  </div>
  <ng-container
    *ngIf="
      (loading$ | async) && !(managementService.poolersByQuery$ | async)?.length
    ">
    <div class="custom-table-row loading-spinner pt-2 ps-2">
      <mat-spinner diameter="34"></mat-spinner>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      (managementService.poolersByQuery$ | async)?.length === 0 &&
      !(loading$ | async)
    ">
    <div class="pb-2 pt-2 ps-2">
      {{ ("noPoolerFound" | i18n) || "Keine Pooler gefunden" }}
    </div>
  </ng-container>
  <cdk-virtual-scroll-viewport
    #cdkScroll
    minBufferPx="300"
    maxBufferPx="600"
    class="virtual-vertical-scroll"
    (scroll)="updateHeaderScrollPosition($event)"
    itemSize="48">
    <ng-container
      class="user-details mt-1"
      *cdkVirtualFor="
        let baseUser of managementService.sortedUsers$ | async;
        trackBy: trackByUserId
      ">
      <ng-container
        *ngIf="
          (renderedPreparedUsers$ | async)?.get(baseUser._id) as user;
          else userSkeleton
        ">
        <div
          class="table-row"
          [attr.data-cy]="'user-table-row-' + user._id">
          <div class="table-cell main-label-cell sticky-main-cell-left">
            <div
              class="name"
              (click)="toggleDetails(user)">
              <div class="name-wrapper">
                <div
                  class="person-name"
                  [title]="user.firstName + ' ' + user.lastName">
                  {{ formatUserName(user) }}
                </div>
                <div
                  *ngIf="user.customerOfUser"
                  [title]="user.customerOfUser.name"
                  class="source-customer"
                  [attr.data-cy]="'source-customer-' + user.customerOfUser._id">
                  {{ "via " + user.customerOfUser.name }}
                </div>
              </div>
              <span
                *ngIf="
                  user.customerInformation?.[loggedInUser.customerId] &&
                  user.customerInformation?.[loggedInUser.customerId]?.poolerType
                ">
                <mat-chip class="pooler-type-chip">
                  {{user?.customerInformation?.[loggedInUser.customerId]?.poolerType?.displayName | uppercase }}
                </mat-chip>
              </span>
            </div>
          </div>
          <div class="table-row-content">
            <ng-container
              *ngFor="
                let availabilityDate of availabilityDays$ | async;
                let dayIndex = index
              ">
              <div
                class="table-cell"
                [class.first-weekday]="(availabilityDate | date: 'cc') === '1'"
                [class.selected]="
                  (selectedDatesEndIndex$ | async) &&
                  (selectedDatesStartIndex$ | async) &&
                  dayIndex <= ((selectedDatesEndIndex$ | async) || 0) &&
                  dayIndex >= ((selectedDatesStartIndex$ | async) || 0)
                "
                [class.first-selected]="
                  (selectedDatesStartIndex$ | async) &&
                  dayIndex === (selectedDatesStartIndex$ | async)
                "
                [class.last-selected]="
                  (selectedDatesEndIndex$ | async) &&
                  dayIndex === (selectedDatesEndIndex$ | async)
                "
                [class.is-today]="
                  availabilityDate === today &&
                  ((managementService.calendarRange$ | async)?.from
                    | date: 'yyyy-MM-dd') !== today
                "
                [matTooltipShowDelay]="300"
                [matTooltip]="(availabilityDate | date: 'dd.MM.yyy') || ''"
                matTooltipPosition="above"></div>
            </ng-container>
            <ng-container
              *ngFor="
                let availability of user.employmentAvailabilitiesWithLength
              ">
              <div
                class="employment-availability"
                [class.available]="availability.status === statusEnum.AVAILABLE"
                [class.working]="availability.status === statusEnum.WORKING"
                [class.unavailable]="
                  availability.status === statusEnum.UNAVAILABLE
                "
                [class.hovered]="
                  (hoveredMiniAbsence$ | async) === availability.id
                "
                [class.clickable]="
                  user.canEditAvailabilities ||
                  availability.status === statusEnum.AVAILABLE
                "
                [style.width.px]="availability.daysBetween * 12"
                [style.left.px]="12 * availability.daysOffset"
                (click)="
                  $event.preventDefault();
                  onAvailabilityClick(
                    user,
                    availability,
                    matMenuTrigger,
                    $event
                  )
                ">
                <div
                  style="
                    height: 0;
                    width: 0;
                    pointer-events: none;
                    position: absolute;
                  "
                  [style.top]="
                    ((clickPositionInAvailability$ | async)?.y || 24) + 'px'
                  "
                  [style.left]="
                    ((clickPositionInAvailability$ | async)?.x || 0) + 'px'
                  "
                  [matMenuTriggerFor]="actionSelectionMenu"
                  [matMenuTriggerData]="{
                    user: user,
                    availability: availability
                  }"
                  #matMenuTrigger="matMenuTrigger"></div>
                <ng-container *ngIf="availability.daysBetween < 7">
                  <div
                    class="availability-date only-dots"
                    [attr.title]="
                      (availability.startDate | date: 'dd.MM') +
                      ' - ' +
                      (availability.endDate | date: 'dd.MM')
                    ">
                    ...
                  </div>
                </ng-container>
                <ng-container *ngIf="availability.daysBetween >= 7">
                  <div
                    class="availability-date"
                    [class.hidden-until-hover]="
                      availability.daysVisibleStart < 7
                    "
                    [attr.title]="availability.startDate | date: 'dd.MM'">
                    {{ availability.startDate | date: "dd.MM" }}
                  </div>
                  <ng-container *ngIf="availability.daysVisibleStart < 7">
                    <div
                      class="availability-date date-dots"
                      [attr.title]="availability.startDate | date: 'dd.MM'">
                      ...
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      availability.daysBetween >= 21 &&
                      availability.bookedEmployment
                    ">
                    <ng-container
                      *ngIf="
                        availability.bookedEmployment.inviteeCustomerId ===
                          loggedInUser.customerId;
                        else bookedAnonymized
                      ">
                      <ng-container
                        *ngIf="organisationMap$ | async as organisationMap">
                        <div
                          class="availability-detail"
                          *ngIf="
                            organisationMap.get(
                              availability.bookedEmployment.organisation.id
                            )
                          ">
                          <span class="availability-detail__bold">
                            {{
                              availability.bookedEmployment.organisation.name
                            }}
                          </span>
                          <span class="availability-detail__ellipsis">
                            {{ availability.bookedEmployment.department.name }}
                          </span>
                        </div>
                        <div
                          *ngIf="
                            !organisationMap.get(
                              availability.bookedEmployment.organisation.id
                            )
                          ">
                          <span class="availability-detail__bold">
                            {{ "otherOrganisation" | i18n }}
                          </span>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #bookedAnonymized>
                      <div class="availability-detail">
                        {{ ("inEmployment" | i18n) || "Im Einsatz" }}
                      </div>
                    </ng-template>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      availability.daysBetween >= 14 &&
                      availability.unavailableReason
                    ">
                    <div class="availability-detail">
                      <span class="availability-detail__bold">
                        {{
                          ("unavailabilityReasonEnum." +
                            availability.unavailableReason | i18n) ||
                            availability.unavailableReason
                        }}
                      </span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      availability.daysBetween >= 14 &&
                      availability.workload &&
                      availability.status === statusEnum.AVAILABLE
                    ">
                    <div class="availability-detail">
                      <span class="availability-detail__bold">
                        {{ availability.workload }}%
                        {{ ("workload" | i18n) || "Pensum" }}
                      </span>
                    </div>
                  </ng-container>
                  <div
                    class="availability-date"
                    [class.hidden-until-hover]="availability.daysVisibleEnd < 7"
                    [attr.title]="availability.endDate | date: 'dd.MM'">
                    {{ availability.endDate | date: "dd.MM" }}
                  </div>
                  <ng-container *ngIf="availability.daysVisibleEnd < 7">
                    <div
                      class="availability-date date-dots"
                      [attr.title]="availability.endDate | date: 'dd.MM'">
                      ...
                    </div>
                  </ng-container>
                </ng-container>
              </div>
              <div
                *ngIf="availability.status === statusEnum.UNAVAILABLE"
                class="employment-availability unavailable-small"
                (mouseenter)="hoveredMiniAbsence$.next(availability.id)"
                (mouseleave)="hoveredMiniAbsence$.next(undefined)"
                [style.width.px]="availability.daysBetween * 12"
                [style.left.px]="12 * availability.daysOffset"></div>
            </ng-container>
          </div>
        </div>
        <div
          class="table-row details-table-row"
          *ngIf="!user.detailsCollapsed"
          [attr.data-cy]="'user-list-item-details-' + user._id">
          <user-list-item-details
            class="user-details mt-1"
            [user]="user"></user-list-item-details>
        </div>
      </ng-container>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>

<ng-template #userSkeleton>
  <app-employment-availabilities-user-list-skeleton></app-employment-availabilities-user-list-skeleton>
</ng-template>

<mat-menu
  #actionSelectionMenu="matMenu"
  class="fixed-icon-mat-menu">
  <ng-template
    matMenuContent
    let-availability="availability"
    let-user="user">
    <button
      mat-menu-item
      type="button"
      (click)="openCreateEmploymentDialog(user, availability)">
      <mat-icon
        svgIcon="add-circle-plus"
        class="book"></mat-icon>
      <span>{{ "newEmployment" | i18n }}</span>
    </button>
    <button
      mat-menu-item
      type="button"
      (click)="editAvailability(user._id, availability.id)">
      <mat-icon
        svgIcon="pencil-outline"
        class="book"></mat-icon>
      <span>{{ "editAvailability" | i18n }}</span>
    </button>
  </ng-template>
</mat-menu>
